import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { NonLifeInsuranceFormFields } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/NonLifeInsuranceFormFields";
import type { NonLifeInsuranceType } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceTypes";
import { useCreateNonLifeInsuranceForm } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/useCreateNonLifeInsuranceForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type CreateNonLifeInsuranceFormProps = {
	insuranceType: NonLifeInsuranceType;
};

export const CreateNonLifeInsuranceForm = ({
	insuranceType,
}: CreateNonLifeInsuranceFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateNonLifeInsuranceForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<NonLifeInsuranceFormFields
				control={form.control}
				insuranceType={insuranceType}
			/>
		</PortfolioFormShell>
	);
};
